module.exports = __webpack_public_path__ + "static/media/publicsonar_publicsafety_hover.866ef40d.svg";